<template>
  <div class="consultation">
    <div v-show="!showIsReccept && !showIsCall">
      <div class="contianer" v-if="hasMask">
        <div class="waiting-cover">
          <div class="waiting">
            {{ userInfo.inquiryType == 2 ? '等待医生回复' : '正在为您寻找医生' }}
            <img src="../../assets/gif/loadingycf.gif" alt="" srcset="">
          </div>
        </div>
      </div>
      <div class="nav-head" v-if="!hasMask">
        <div class="back">
          <img src="../../assets/image/nav_back.png" @click="goBack">
        </div>
        <div class="nav-title">{{ navTitle }}</div>
      </div>
      <div class="contianer" ref="container" v-if="!hasMask">
        <div class="more-message" v-if="!isCompleted" @click="getMessageList">更多消息</div>
        <div class="no-more-message" v-else>暂无更多消息</div>
        <MessageItem :options="item" v-for="(item, index) in messageList" :key="'messageList' + index"></MessageItem>
        <div class="seat"></div>
      </div>
      <div class="send" v-if="step === 1">
        <div class="send-btn">
          <div class="image-more">
            <img src="../../assets/image/image_more.png" alt="" srcset="">
            <Upload accept="image/*" @updateImage="sendImage" :choose="true"></Upload>
            <span>上传图片</span>
          </div>
          <div class="image-more mg-l-12" @click="isSend">
            <img src="../../assets/image/icon_video@2x.png" alt="" class="">
            <span>拨打视频</span>
          </div>
        </div>
        <div class="send-area">
          <div class="send-input">
            <input type="text" v-model="inputValue" placeholder="请输入您要咨询的问题" />
          </div>
          <div class="send-button-area">
            <div class="send-button" @click="sendMsg" :class="deviceType == 'alipay' ? 'color-bg-huafu' : ''">发送
            </div>
          </div>
        </div>
      </div>
      <div class="end-inq" v-if="step >= 2">
        <div class="close-inquiry">
          <h3>问诊已关闭</h3>
          <span>
            如仍需帮助，请再次发起问诊
          </span>
        </div>
        <button
          class="end-button"
          @click="checkThird"
          type="primary"
        >
          结束问诊
        </button>
      </div>
    </div>
    <div class="video_main" v-show="showIsCall" style="background-color: #1B232F">
      <div class="yfw-header-hang">
        <div class="hang-title">
          <img src="../../assets/image/avatarDoctor.png" alt="">
        </div>
        <p class="hang-name" style="color: white">{{orderDetail.doctorName}}</p>
      </div>
      <div class="video-dialog_footer yfw-footer-hang" style="height: 160px !important">
        <div class="hang-wrap" @click="showIsCall = false">
          <span style="color: white">等待接听中...</span>
          <i class="hang-icon"><img src="../../assets/image/icon_endCall@2x.png" alt=""></i>
          <span style="color: white">挂断</span>
        </div>
      </div>
    </div>
    <div class="video-component" v-show="showVideo">
      <TUICallKit
        :allowedMinimized="false"
        :allowedFullScreen="false"
      />
    </div>
  </div>
</template>

<script>
import { TUICallKit, TUICallKitServer } from '@tencentcloud/call-uikit-vue';
import { showNotify, showToast, showDialog } from 'vant';
import { mapMutations, mapGetters } from 'vuex';
import { getUrlParams } from '../../utils/const'
import MessageItem from '../../components/messageItem/BaseMessageItem.vue';
import Upload from '@/components/upload'
import TencentCloudChat from '@tencentcloud/chat';
import patientReplyMixin from '@/mixins/patientReply'

export default {
  name: 'trtcCalling',
  mixins: [patientReplyMixin],
  components: {
    MessageItem,
    TUICallKit,
    Upload
  },

  data () {
    return {
      showVideo: false,
      inputValue: '',
      inputVideo: '医生正在视频中，请不要离开当前页面，医生即将回拨或稍后重试',
      logined: false,
      messageList: [],
      nextReqMessageID: 0,
      isCompleted: false,
      timer: null,
      showIsReccept: false,
      showIsCall: false,
      hasSend: false,
      countTime: 60,
      getTime: '', // 通话时长
      callingTimer: null,
    }
  },
  computed: {
    ...mapGetters(['step', 'orderDetail', 'userInfo', 'hasMask', 'imInfo', 'urlParams', 'deviceType', 'endInquiry', 'timDuration']),
    navTitle () {
      if (this.orderDetail.sectionName && this.orderDetail.doctorName) {
        return this.orderDetail.sectionName + '  ' + this.orderDetail.doctorName
      } else {
        return '医生问诊'
      }
    }
  },
  mounted () {
    const deviceType = this.deviceType || getUrlParams()['deviceType']
    window.addEventListener('popstate', () => {
      if (deviceType === 'wechat') {
        wx.miniProgram.navigateBack({
          delta: history.length
        });
      } else if (deviceType === 'uniapp') {
        window.postMessage({
          data: {
            action: 'popstate'
          }
        }, '*')
        uni.postMessage({
          data: {
            action: 'popstate'
          }
        })
      } else {
        history.go(-(history.length - 2));
      }
    });
  },
  async created () {
    await this.getUrlParams()
    await this.getOrderStatusInfo()
    this.timListener()
    this.trtcLogin()
    setTimeout(() => {
      this.initTrtcEvent()
    }, 500)
  },

  watch: {

  },
  methods: {
    initTrtcEvent () {
      TUICallKitServer._tuiCallEngine.on('onCallReceived', (event) => {
        this.showVideo = true
        this.showIsCall = false
      })
      TUICallKitServer._tuiCallEngine.on('onCallEnd', (event) => {
        if (event.totalTime) {
          this.inputValue = this.getTalkTime(event.totalTime)
          this.sendMsg();
        }
        this.showVideo = false
      })
    },
    checkThird () {
      const { bizID, inquiryOrderID } = this.orderDetail;
      const deviceType = this.deviceType || getUrlParams()['deviceType']
      const params = {
        bizID: bizID,
        inquiryID: inquiryOrderID,
        deviceType: deviceType,
        requireType: 'finishInquiry'
      }
      this.$_http
        .post(this.$_API.H5_INQUIRY_POST_CHECKTHIRD, params)
        .then(res => {
          const { url } = res.data;
          if (url === '') {
            // this.goBack()
            this.$router.back()
          } else {
            if (deviceType === 'wechat') {
              wx.miniProgram.navigateTo({
                url
              });
            } else if (deviceType === 'uniapp') {
              window.postMessage({
                data: {
                  action: 'finishOrder',
                  url
                }
              }, '*')
              uni.postMessage({
                data: {
                  action: 'finishOrder',
                  url
                }
              })
            } else {
              window.location.href = `${url}`;
            }
          }
        });
    },
    async getOrderStatusInfo () {
      if (!this.urlParams.orderID) {
        return false
      }
      let params = {
        orderID: this.urlParams.orderID
      }
      await this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_ORDER_STATUS, { params }).then(res => {
        if (res.success) {
          clearInterval(this.statusTimer);
          this['user/updateOrderDetail']({ ...this.orderDetail, ...res.data, doctorID: res.data.doctorIMID, userSig: res.data.patientUserSig })
          if (!this.userInfo.patientInfo) {
            this['user/updateUserInfo']({ ...this.userInfo, patientInfo: { patientName: res.data.patientName } })
          }
          this.toPage()
        }
      })
    },
    toPage () {
      // 问诊状态(0:无 / 1:待派单 / 2:已派单待接诊 / 3:已接诊 / 4:接诊完成 / 5:医生取消 / 6:患者取消 / 7:超时 / ）
      if (this.orderDetail.inquiryStatus === 1) {
        this.$router.replace({
          path: '/waiting',
          query: {
            ...this.urlParams
          }
        })
      } else if (this.orderDetail.inquiryStatus > 1 && this.orderDetail.inquiryStatus < 5) {
        if (this.orderDetail.inquiryStatus === 4) {
          this['global/updateStep'](3)
        } else {
          this['global/updateStep'](1)
        }
        if (this.orderDetail.inquiryType === 1) {
          this.$router.replace({
            path: '/consultation',
            query: {
              ...this.urlParams
            }
          })
        } else if (this.orderDetail.inquiryType === 2) {
          this.$router.replace({
            path: '/trtcCalling',
            query: {
              ...this.urlParams
            }
          })
        }
      } else if (this.orderDetail.inquiryStatus >= 5) {
        showDialog({
          message: '问诊已取消，请退出后重新发起问诊',
          confirmButtonText: '知道了',
          confirmButtonColor: '#438BEF',
          closeOnClickOverlay: true
        }).then(() => {
          this.$router.replace({
            path: '/',
            query: {
              ...this.urlParams
            }
          })
        });
      }
    },
    getCountTime () {
      this.timer = setInterval(() => {
        this.countTime--
        if (this.countTime < 0) {
          this.hasSend = false;
          this.countTime = 60;
          clearInterval(this.timer)
        }
      }, 1000)
    },
    async trtcLogin () {
      await TUICallKitServer.destroyed()
      await TUICallKitServer.init({
        tim: this.tim,
        SDKAppID: parseInt(process.env.VUE_APP_SDK_APP_ID),
        userID: this.imInfo.patientImID || this.orderDetail.patientIMID,
        userSig: this.imInfo.userSig || this.orderDetail.userSig
      });
    },
    // 快速问诊-获取IM登录信息
    getImInfo () {
      if (!this.orderDetail.bizID) {
        return false
      }
      let params = {
        patientInfoID: '',
        bizID: this.orderDetail.bizID,
        clientID: this.orderDetail.clientID,
        clientAppID: this.orderDetail.clientAppID,
        timestamp: this.orderDetail.timestamp,
        sign: this.orderDetail.sign
      }
      this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_IM_INFO, { params }).then(res => {
        if (res.success && res.data.orderStatus < 1) {

        }
      })
    },
    // getMessage
    getMessageList () {
      if (this.isCompleted) {
        return false
      }
      let params = { conversationID: 'C2C' + this.orderDetail.doctorID, count: 15 }
      let _that = this
      if (this.nextReqMessageID !== 0) {
        params.nextReqMessageID = this.nextReqMessageID
      }
      // 打开某个会话时，第一次拉取消息列表
      let promise = this.tim.getMessageList(params);
      promise.then(function (imResponse) {
        console.log(imResponse)
        const messageList = imResponse.data.messageList; // 消息列表。
        const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
        const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        for (let i = messageList.length - 1; i >= 0; i--) {
          if (typeof messageList[i].payload.data === 'string' && messageList[i].type === 'TIMCustomElem') {
            let data = JSON.parse(messageList[i].payload.data)
            console.log(data)
            if (data.customType === 'card') {
              if (data.childType === 'rpImg') {
                let FileMessage = {
                  progress: 100,
                  from: _that.orderDetail.patientIMID + '1',
                  type: 'TIMImageElem',
                  src: data.data.rpImgUrl,
                  payload: {
                    data: 'imageMessage'
                  }
                }
                _that['global/updateStep'](2)
                messageList.splice(i, 1, FileMessage)
              }
            } else if (data.customType === 'sys') {
              if (data.childType === 'doctor_reject') {
                this['global/updateStep'](2)
              } else if (data.childType === 'doctor_pass') {
                this['global/updateStep'](3)
              }
            }
            if (_that.step === 3 || _that.step === 2) {
              break;
            }
          }
        }
        if (_that.nextReqMessageID === 0) {
          _that.messageList.unshift(...messageList.slice(0, messageList.length - _that.messageList.length))
        } else {
          _that.$nextTick(function () {
            _that.messageList.unshift(...messageList)
          })
        }
        console.log(1111)
        console.log(_that.messageList)
        _that.nextReqMessageID = nextReqMessageID
        _that.isCompleted = isCompleted
        _that.handleScrollBottom()
      });
    },
    // 添加监听消息
    timListener () {
      // 收到新消息
      this.tim.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
      this.tim.on(TencentCloudChat.EVENT.SDK_READY, this.sdkReady);
    },
    // sdk监听初始化成功，tim ready状态
    sdkReady (event) {
      this.logined = true
      this.getMessageList()
    },
    // 通话时长格式化
    getTalkTime (totalTime) {
      const getTime = totalTime
      let m = parseInt((getTime % 3600) / 60);
      if (m < 10) {
        m = '0' + m
      }
      let s = ((getTime % 3600) % 60);
      if (s < 10) {
        s = '0' + s
      }
      this.talkTime = `视频时长 ${m}:${s}`
      return this.talkTime
    },
    // 监听收到消息的事件
    onReceiveMessage (event) {
      console.log('=================')
      // console.log('event', event)
      // const endTxt = '本次会话已关闭~如有非医学类问题咨询，请联系客服哦~'
      if (event.data[0].payload.description === 'inquiryFinish' && event.data[0].type === 'TIMCustomElem') {
        this['global/updateStep'](2)
      }
      if (typeof event.data[0].payload.data === 'string' && event.data[0].type === 'TIMCustomElem') {
        let data = JSON.parse(event.data[0].payload.data)
        console.log('消息详情==', data)
        if (data.actionType === 1) { // 通话时长
          let jsonData = JSON.parse(data.data)
          console.log(jsonData)
          if (jsonData.data.cmd === 'hangup' && this.timDuration.videoStart !== '') {
            this.getTime = jsonData.call_end
          }
        }
        if (data.customType === 'sys') {
          if (data.childType === 'doctor_reject') {
            this['global/updateStep'](2)
          } else if (data.childType === 'doctor_pass') {
            this['global/updateStep'](3)
          } else if (data.childType === 'sendDoctorInfo') {
            this['global/updateDoctorInfo'](data.data)
          } else if (data.childType === 'rp_order_start') {
            this['global/updateStep'](1)
            this['user/updateOrderDetail']({ ...this.orderDetail, doctorID: JSON.parse(event.data[0].payload.data).data.doctorID })
            this['global/updateMask'](false)
          }
          return false
        } else if (data.customType === 'card') {
          if (data.childType === 'rpImg') {
            let FileMessage = {
              progress: 100,
              from: this.orderDetail.patientIMID + '1',
              type: 'TIMImageElem',
              src: data.data.rpImgUrl,
              payload: {
                data: 'imageMessage'
              }
            }
            this['global/updateStep'](2)
            this.messageList.push(FileMessage)
            this.handleScrollBottom()
            return false
          }
        }
      }
      this.messageList.push(event.data[0])
      this.handleScrollBottom()
    },
    sendVideo () {
      let _that = this
      if (!this.logined) {
        showNotify({
          type: 'warning',
          message: '请先登录',
          duration: 1000
        });
        return false;
      }
      const mesData = {
        customType: 'hint',
        dataType: 'hint',
        data: {
          text: _that.inputVideo
        }
      }
      console.log(JSON.stringify(mesData))
      let message = this.tim.createCustomMessage({
        to: this.orderDetail.doctorID,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
          data: JSON.stringify(mesData),
          description: '申请拨打视频',
          extension: 'ycf'
        }
      });
      let promise = this.tim.sendMessage(message);
      promise.then(function (imResponse) {
        // 发送成功
        _that.reportPatientReply(0)
        _that.messageList.push(imResponse.data.message)
        _that.hasSend = true;
        _that.getCountTime();
        _that.handleScrollBottom()
      }).catch(function (imError) {
        // 发送失败
        console.log('sendMessage error:', imError);
        showNotify({
          type: 'warning',
          message: '发送失败',
          duration: 1000
        });
        return false;
      });
    },
    // 发送视频申请
    isSend () {
      this.sendVideo()
      this.showIsCall = true
      this.callingTimer = setTimeout(() => {
        if (this.showIsCall) {
          this.showIsCall = false
          showToast('医生正在忙碌，请重新发起问诊，或稍后再试');
        }
      }, 30000);
    },
    sendMsg () {
      let _that = this
      if (!this.logined) {
        showNotify({
          type: 'warning',
          message: '请先登录',
          duration: 1000
        });
        return false;
      }
      let message = this.tim.createTextMessage({
        to: this.orderDetail.doctorID,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
          text: this.inputValue
        }
      });
      let promise = this.tim.sendMessage(message);
      promise.then(function (imResponse) {
        // 发送成功
        _that.messageList.push(imResponse.data.message)
        _that.inputValue = ''
        _that.handleScrollBottom()
      }).catch(function (imError) {
        // 发送失败
        console.log('sendMessage error:', imError);
        showNotify({
          type: 'warning',
          message: '发送失败',
          duration: 1000
        });
        return false;
      });
    },
    // 发送消息、获取消息向下滚动
    handleScrollBottom () {
      setTimeout(() => {
        let dom = this.$refs.container
        if (!dom || dom.scrollHeight === 0) {
          return false;
        }
        dom.scrollTop = dom.scrollHeight - dom.clientHeight
      }, 100)
    },
    // 选取发送照片
    sendImage ({ files, id, type }) {
      let _that = this
      let blob = new Blob([files[0]]);
      let FileMessage = null
      let message = null
      if (type === 'image') {
        FileMessage = {
          progress: 0,
          from: _that.orderDetail.patientIMID,
          type: 'TIMImageElem',
          src: window.URL.createObjectURL(blob),
          payload: {
            data: 'imageMessage'
          }
        }
        message = _that.tim.createImageMessage({
          to: this.orderDetail.doctorID,
          conversationType: TencentCloudChat.TYPES.CONV_C2C,
          payload: {
            file: files[0]
          },
          onProgress: function (event) {
            FileMessage.progress = event * 100
          }
        });
      } else if (type === 'video') {
        FileMessage = {
          progress: 0,
          from: _that.orderDetail.patientIMID,
          type: 'TIMVideoFileElem',
          src: window.URL.createObjectURL(blob),
          payload: {
            data: 'videoMessage'
          }
        }
        message = _that.tim.createVideoMessage({
          to: this.orderDetail.doctorID,
          conversationType: TencentCloudChat.TYPES.CONV_C2C,
          payload: {
            file: files[0]
          },
          onProgress: function (event) {
            FileMessage.progress = event * 100
          }
        });
      }
      _that.messageList.push(FileMessage)
      _that.popupDialog = false
      _that.$nextTick(function () {
        _that.handleScrollBottom()
      })
      // 2. 发送消息
      let promise = _that.tim.sendMessage(message);
      promise.then(function (imResponse) {
        // 发送成功
        if (type === 'image') {
          _that.reportPatientReply(1)
        }
      }).catch(function (imError) {
        // 发送失败
        console.warn('sendMessage error:', imError);
        showNotify({
          type: 'warning',
          message: '发送失败',
          duration: 1000
        });
      });
    },
    goBack () {
      // this.$router.back()
      const deviceType = this.deviceType || getUrlParams()['deviceType']
      showDialog({
        title: '退出提示',
        message: '您确定要离开对话吗？',
        confirmButtonText: '确定',
        confirmButtonColor: '#438BEF',
        showCancelButton: true,
        cancelButtonText: '取消',
        cancelButtonColor: '#438BEF',
        closeOnClickOverlay: true
      }).then(() => {
        if (deviceType === 'wechat') {
          wx.miniProgram.navigateBack({
            delta: history.length
          });
        } else if (deviceType === 'uniapp') {
          window.postMessage({
            data: {
              action: 'popstate'
            }
          }, '*')
          uni.postMessage({
            data: {
              action: 'popstate'
            }
          })
        } else {
          this.$router.back()
          // history.go(-(history.length - 2));
        }
      })
    },
    getUrlParams () {
      if (this.$route.name === 'rpViewer') return
      let obj = getUrlParams()
      if (!obj['orderID'] || !obj['token']) {
        showDialog({
          message: '参数缺失，请重新进入',
          confirmButtonText: '确定',
          confirmButtonColor: '#438BEF',
          closeOnClickOverlay: true
        });
      }
      this['global/updateUrlParams'](obj)
    },
    ...mapMutations(['global/updateStep', 'global/updateDoctorInfo', 'user/updateOrderDetail', 'global/updateMask', 'global/updateUrlParams', 'user/updateUserInfo', 'global/updateVideoStart', 'global/updateDuration'])
  },
  unmounted () {
    this.isCompleted = false
    this.tim.logout()
    this.messageList = []
    this.nextReqMessageID = 0
    TUICallKitServer.destroyed()
    this.tim.off(TencentCloudChat.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
    this.tim.off(TencentCloudChat.EVENT.SDK_READY, this.sdkReady);
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/common.scss';
.consultation {
    // margin-top: 44px;
    // height: calc(100vh - 2rem);
}

.seat {
    height: 15px;
    width: 100%;
}

.nav-head {
    position: fixed;
    z-index: 999;
    left:0;
    top:0;
    width: 100%;
    height: 44px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    .back {
        margin-top: 8px;
        margin-left: 8px;
        img {
          width: 24px;
        }
    }
    .nav-title {
        font-size: 18px;
        display: flex;
        justify-content: center;
        width: calc(100% - 36px);
        margin-right: 36px;
    }
}

.contianer {
    height: calc(100vh - 44px - 100px);
    overflow: auto;
    // margin: 44px 0;
    position: absolute;
    width: 100%;
    z-index: 888;
    margin-top: 44px;
    // padding-bottom: 60px;
}

.message-item {
    margin-top: 16px;
}
.send {
  height: 112px;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 9999;
}
.send-btn {
  height: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
}
.send-area {
    height: 64px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
}

.image-more > img {
    height: 24px;
    margin-right: 4px;
}

.image-more > span {
  white-space: nowrap;
}

.image-more {
    // padding: 14px 16px;
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 4px 12px;
    background-color: #ffffff;
    border-radius: 16px;
    margin-left: 12px;
}
.mg-l-12 {
  margin-left: 12px;
}
.image-more > .upload-input-cover {
    opacity: 0;
    position: absolute;
    // height: 32px;
    // width: 80px;
    // top: 14px;
    // left: 16px;
    top: 0;
    left: 0;
}

.send-input {
    flex: 1;
}

.send-button-area {
    padding: 8px 12px 20px;
}

.send-button {
    color: white;
    height: 36px;
    padding: 0 20px;
    line-height: 36px;
    text-align: center;
    background: #438bef;
    border-radius: 20px;
    font-size: 14px;
}
.send-input {
    border-radius: 20px;
    background: #f6f6f6;
    justify-content: center;
    display: flex;
    align-items: center;
    height: 36px;
    margin-left: 12px;
    margin-bottom: 12px;
    input {
        font-size: 14px;
    }
}

.send-input > input {
    background: none;
    height: 90%;
    width: calc(100% - 36px);
}

.more-message,
.no-more-message {
    color: #2887e8;
    font-size: 13px;
    padding: 10px 10px 0;
    text-align: center;
}

.waiting {
    background: #def3ea;
    color: #0a6f41;
    padding: 10px 16px;
    font-size: 14px;
    display: inherit;
    border-radius: 8px;
    margin-top: 24px;
    align-items: center;
}

.waiting > img {
    height: 24px;
    width: 24px;
}

.waiting-cover {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-video {
    width: 26px;
    height: 28px;
    img {
        width: 100%;
    }
}

// 接听视频
.video_main {
    height: 100vh;
    background-color: #ffffff;
}
.network-video {
    width: 16px;
    height: 16px;
    margin: 5px 0;
    cursor: pointer;
    img {
        width: 100%;
    }
}
.network-tips {
    font-size: 14px;
    color: #c0c4cc;
}
.yfw-header-hang {
    position: absolute;
    left: 0;
    top: 20%;
    width: 100%;
    color: #262626;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .hang-title {
        width: 64px;
        height: 64px;
        background-color: #ccd4dd;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        img {
            width: 100%;
        }
    }
    .hang-name {
        font-size: 15px;
        margin: 10px 0;
    }
    .hang-tips {
        font-size: 12px;
    }
}
.yfw-footer-hang {
    display: flex;
    justify-content: space-around;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 140px;
    .hang-wrap {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
            color: #000000;
            font-size: 14px;
        }
        .hang-icon {
            width: 64px;
            height: 64px;
            margin: 8px 0;
            img {
                width: 100%;
            }
        }
    }
}
.send-end {
    font-size: 15px;
    background-color: #ffffff;
    text-align: center;
    padding: 12px 0;
}
.end-button {
  font-size: 14px;
  color: #fff;
  border: none;
  background-color:  var(--primary-color);
  padding: 5px 20px;
  margin: 18px 0;
  border-radius: 4px;
}
.end-inq {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
}
.close-inquiry {
  h3 {
    font-size: 14px;
    position: absolute;
    top: 12px;
  }
  span {
    font-size: 12px;
    color: #666;
    position: absolute;
    top: 36px;
  }
}
.video-component{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
</style>
<style lang="scss">

</style>
